import { Login, LoadingEllipsis, PageTitle } from '@gplibraries/react/components';

export default function LoginPage(props) {

  return (
    <>
      <PageTitle>Log in</PageTitle>
      <div>
        Please wait while we log you in<LoadingEllipsis/>
      </div>
      <Login returnUri={'/'}/>
    </>
  );
}